import * as types from "../types/types";

export const userNotificationActions = (data)=>({
    payload:data,
    type: types.USER_NOTIFICATION_DETAILS
});
